import React, { useMemo, useContext } from 'react';
import { DSPillGroupV2, DSPillV2 } from '@elliemae/ds-pills-v2';
import ComboBoxContext from '../../ComboBoxCTX.js';
import { useGroupPills } from './useGroupPills.js';
import type { DSComboboxT } from '../../react-desc-prop-types.js';
import { ComboboxDataTestid } from '../../ComboboxDataTestids.js';
import { RemovableSelectedValuePill } from './RemovableSelectedValuePill.js';

export const MultiSelectedValuesContainer = (): JSX.Element => {
  const {
    props: { selectedValues, disabled, applyAriaDisabled: applyAriaDisabledToContainer, readOnly },
    pillGroupRef,
  } = useContext(ComboBoxContext);

  // this is always an array because logic in controls component
  const multiSelectedValue = selectedValues as DSComboboxT.ItemOption[];
  const correctPillsToShow = useGroupPills();

  return useMemo(
    () => (
      <div
        style={{ width: multiSelectedValue.length > 0 ? 'max-content' : '0px' }}
        data-testid={ComboboxDataTestid.SELECTED_VALUES}
      >
        <DSPillGroupV2 innerRef={pillGroupRef}>
          {multiSelectedValue.length > 0 &&
            multiSelectedValue
              .slice(0, correctPillsToShow)
              .map((pill, idx) => (
                <RemovableSelectedValuePill
                  key={pill.dsId}
                  pill={pill}
                  trailingComma={
                    ((disabled || applyAriaDisabledToContainer || readOnly) && idx + 1 < correctPillsToShow) ||
                    (multiSelectedValue.length > 0 && correctPillsToShow !== multiSelectedValue.length)
                  }
                />
              ))}
          {multiSelectedValue.length > 0 && correctPillsToShow !== multiSelectedValue.length && (
            <DSPillV2
              size="s"
              labelTruncated={false}
              key="grouped"
              label={`+${multiSelectedValue.length - correctPillsToShow}`}
              type="value"
              disabled={disabled}
              applyAriaDisabled={applyAriaDisabledToContainer}
              readOnly={readOnly}
            />
          )}
        </DSPillGroupV2>
      </div>
    ),

    [pillGroupRef, multiSelectedValue, correctPillsToShow, disabled, applyAriaDisabledToContainer, readOnly],
  );
};
